const TEAM_ABBREVIATION_OVERRIDES: Record<string, string> = {
  ARZ: "ARI",
  JAC: "JAX",
  NWE: "NE",
  NOR: "NO",
  TAM: "TB",
  GNB: "GB",
  KAN: "KC",
  SFO: "SF",
  WAS: "WSH",
  WFT: "WSH",
  OAK: "LV",
  LVR: "LV",
  SD: "LAC",
  STL: "LAR",
  LA: "LAR",
  NEP: "NE",
  NOS: "NO",
  TBB: "TB",
  GBP: "GB",
  KCC: "KC",
};

const TEAM_LOGO_KEYS: Record<string, string> = {
  ARI: "ari",
  ATL: "atl",
  BAL: "bal",
  BUF: "buf",
  CAR: "car",
  CHI: "chi",
  CIN: "cin",
  CLE: "cle",
  DAL: "dal",
  DEN: "den",
  DET: "det",
  GB: "gb",
  HOU: "hou",
  IND: "ind",
  JAX: "jax",
  KC: "kc",
  LV: "lv",
  LAC: "lac",
  LAR: "lar",
  MIA: "mia",
  MIN: "min",
  NE: "ne",
  NO: "no",
  NYG: "nyg",
  NYJ: "nyj",
  PHI: "phi",
  PIT: "pit",
  SEA: "sea",
  SF: "sf",
  TB: "tb",
  TEN: "ten",
  WSH: "wsh",
};

const TEAM_PRIMARY_COLORS: Record<string, string> = {
  ARI: "#97233f",
  ATL: "#a71930",
  BAL: "#241773",
  BUF: "#00338d",
  CAR: "#0085ca",
  CHI: "#0b162a",
  CIN: "#fb4f14",
  CLE: "#311d00",
  DAL: "#003594",
  DEN: "#fb4f14",
  DET: "#0076b6",
  GB: "#203731",
  HOU: "#03202f",
  IND: "#002c5f",
  JAX: "#006778",
  KC: "#e31837",
  LV: "#000000",
  LAC: "#0080c6",
  LAR: "#003594",
  MIA: "#008e97",
  MIN: "#4f2683",
  NE: "#002244",
  NO: "#d3bc8d",
  NYG: "#0f3d8f",
  NYJ: "#1a8757",
  PHI: "#004c54",
  PIT: "#101820",
  SEA: "#002244",
  SF: "#aa0000",
  TB: "#d50a0a",
  TEN: "#0c2340",
  WSH: "#5a1414",
};

const TEAM_FULL_NAMES: Record<string, string> = {
  ARI: "Arizona Cardinals",
  ATL: "Atlanta Falcons",
  BAL: "Baltimore Ravens",
  BUF: "Buffalo Bills",
  CAR: "Carolina Panthers",
  CHI: "Chicago Bears",
  CIN: "Cincinnati Bengals",
  CLE: "Cleveland Browns",
  DAL: "Dallas Cowboys",
  DEN: "Denver Broncos",
  DET: "Detroit Lions",
  GB: "Green Bay Packers",
  HOU: "Houston Texans",
  IND: "Indianapolis Colts",
  JAX: "Jacksonville Jaguars",
  KC: "Kansas City Chiefs",
  LV: "Las Vegas Raiders",
  LAC: "Los Angeles Chargers",
  LAR: "Los Angeles Rams",
  MIA: "Miami Dolphins",
  MIN: "Minnesota Vikings",
  NE: "New England Patriots",
  NO: "New Orleans Saints",
  NYG: "New York Giants",
  NYJ: "New York Jets",
  PHI: "Philadelphia Eagles",
  PIT: "Pittsburgh Steelers",
  SEA: "Seattle Seahawks",
  SF: "San Francisco 49ers",
  TB: "Tampa Bay Buccaneers",
  TEN: "Tennessee Titans",
  WSH: "Washington Commanders",
};

export function formatTeamAbbreviation(team: unknown, fallback = ""): string {
  const value = String(team ?? "").trim();
  if (!value) return fallback;

  const normalized = value.toUpperCase();
  return TEAM_ABBREVIATION_OVERRIDES[normalized] ?? normalized;
}

export function formatTeamFullName(team: unknown, fallback = ""): string {
  const abbreviation = formatTeamAbbreviation(team);
  return TEAM_FULL_NAMES[abbreviation] ?? (fallback || abbreviation);
}

export function getTeamPrimaryColor(team: unknown, fallback = "#0f172a"): string {
  const abbreviation = formatTeamAbbreviation(team);
  return TEAM_PRIMARY_COLORS[abbreviation] ?? fallback;
}

export function getTeamLogoSrc(team: unknown): string | null {
  const abbreviation = formatTeamAbbreviation(team);
  const key = TEAM_LOGO_KEYS[abbreviation];
  return key ? `/team-logos/nfl/${key}.png` : null;
}
